import React, { useContext, useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { ControlledMenu as RControlledMenu, MenuItem as RMenuItem, SubMenu as RSubMenu } from "@szhsin/react-menu";
import GeneralContext from "../GeneralContext/GeneralContext";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import GenericTextTable from "./GenericTextTable";
import OPReport from "./OPReport";

const MENU_CSS = `
.sagec-menu{--accent:#003B8D;--bg:#fff;--fg:#1f2733;--hover:rgba(0,59,141,0.08);--selected:rgba(0,59,141,0.14);background:var(--bg);color:var(--fg);border:1px solid rgba(0,0,0,0.12);border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.08);padding:8px 0;min-width:320px}
.sagec-menu .szh-menu__item{padding:10px 14px;line-height:1.2;white-space:normal;color:var(--fg);border-radius:6px;margin:0 6px}
.sagec-menu .szh-menu__item--hover{background:var(--hover)}
.sagec-menu .szh-menu__item--active{background:var(--selected)}
.sagec-menu.sagec-submenu{margin-left:-6px;min-width:320px}
`;

const BUTTONS = [
  {
    label: "Reporte de supervisión",
    path: "reporte-de-supervision",
    size: 4,
    children: [
      {
        label: "Monitoreo en Línea",
        path: "reporte-de-supervision/monitoreo",
        to: "supervision/monitoreo",
        api: "/api/supervision/monitoreo",
        columns: [
          { id: "fecha", label: "Fecha", minWidth: 120 },
          { id: "operador", label: "Operador", minWidth: 200 },
          { id: "evento", label: "Evento" }
        ],
        filters: [{ item: "operador", name: "Operador", size: 6 }, { item: "fecha", name: "Fecha", size: 6 }]
      },
      {
        label: "Análisis tráfico y comportamiento",
        path: "reporte-de-supervision/analisis",
        to: "supervision/analisis",
        api: "/api/supervision/analisis",
        columns: [
          { id: "zona", label: "Zona", minWidth: 140 },
          { id: "dominio", label: "Dominio", minWidth: 280 },
          { id: "visitas", label: "Visitas", align: "right", minWidth: 120 }
        ],
        filters: [{ item: "zona", name: "Zona", size: 6 }]
      }
    ]
  },
  {
    label: "Comercial de Servicio de conectividad",
    path: "comercial",
    size: 4,
    children: [
      {
        label: "PREFACTURA",
        path: "comercial/prefactura",
        to: "comercial/prefactura",
        api: "/api/comercial/prefactura",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120 },
          { id: "operador", label: "Operador", minWidth: 200 },
          { id: "monto", label: "Monto", align: "right", minWidth: 140 }
        ],
        filters: [{ item: "periodo", name: "Periodo", size: 6 }, { item: "operador", name: "Operador", size: 6 }]
      },
      {
        label: "Nueva por definir",
        path: "comercial/nueva",
        to: "comercial/nueva",
        api: "/api/comercial/nueva",
        columns: [
          { id: "campo", label: "Campo" },
          { id: "valor", label: "Valor" }
        ]
      }
    ]
  },
  {
    label: "Reporte de Operación",
    path: "reporte-de-operacion",
    size: 4,
    children: [
      {
        label: "Altas/Bajas/Traslado",
        path: "operacion/altas-bajas-traslado",
        to: "operacion/altas-bajas-traslado",
        api: "/api/operacion/altas-bajas-traslado",
        columns: [
          { id: "rbd", label: "RBD", minWidth: 100 },
          { id: "tipo", label: "Tipo", minWidth: 120 },
          { id: "fecha", label: "Fecha", minWidth: 120 },
          { id: "operador", label: "Operador", minWidth: 200 }
        ],
        filters: [{ item: "tipo", name: "Tipo", size: 6 }, { item: "operador", name: "Operador", size: 6 }]
      },
      {
        label: "Cambios de configuración",
        path: "operacion/cambios-config",
        to: "operacion/cambios-config",
        api: "/api/operacion/cambios-config",
        columns: [
          { id: "rbd", label: "RBD", minWidth: 100 },
          { id: "cambio", label: "Cambio" },
          { id: "fecha", label: "Fecha", minWidth: 120 }
        ],
        filters: [{ item: "cambio", name: "Cambio", size: 6 }]
      }
    ]
  },
  {
    label: "Reporte de Uso",
    path: "reporte-de-uso",
    size: 3,
    children: [
      {
        label: "Visitas mensuales por zona",
        path: "uso/visitas-mensuales-por-zona",
        to: "uso/visitas-mensuales-por-zona",
        api: "/api/uso/visitas-mensuales-por-zona",
        columns: [
          { id: "zona", label: "Zona", minWidth: 160 },
          { id: "mes", label: "Mes", minWidth: 120 },
          { id: "visitas", label: "Visitas", align: "right", minWidth: 120 }
        ],
        filters: [{ item: "zona", name: "Zona", size: 6 }, { item: "mes", name: "Mes", size: 6 }]
      },
      {
        label: "Top 10 dominios por zona",
        path: "uso/top-10-por-zona",
        to: "uso/top-10-por-zona",
        api: "/api/uso/top-10-por-zona",
        columns: [
          { id: "zona", label: "Zona", minWidth: 160 },
          { id: "dominio", label: "Dominio", minWidth: 300 },
          { id: "visitas", label: "Visitas", align: "right", minWidth: 120 }
        ],
        filters: [{ item: "zona", name: "Zona", size: 6 }]
      },
      {
        label: "Uso del servicio para muestra de ees",
        path: "uso/ees",
        children: [
          {
            label: "Dominios visitados cada día top 10",
            path: "uso/ees/top-10-diario",
            to: "uso/ees/top-10-diario",
            api: "/api/uso/ees/top-10-diario",
            columns: [
              { id: "fecha", label: "Fecha", minWidth: 120 },
              { id: "operador", label: "Operador", minWidth: 220 },
              { id: "dominio", label: "Dominio", minWidth: 300 },
              { id: "total", label: "Total visitas", align: "right", minWidth: 140 }
            ],
            filters: [{ item: "operador", name: "Operador", size: 6 }, { item: "fecha", name: "Fecha", size: 6 }]
          },
          {
            label: "Visitas por hora del mes en un ees",
            path: "uso/ees/visitas-por-hora",
            to: "uso/ees/visitas-por-hora",
            api: "/api/uso/ees/visitas-por-hora",
            columns: [
              { id: "hora", label: "Hora", minWidth: 120 },
              { id: "rbd", label: "RBD", minWidth: 120 },
              { id: "visitas", label: "Visitas", align: "right", minWidth: 140 }
            ],
            filters: [{ item: "rbd", name: "RBD", size: 6 }, { item: "hora", name: "Hora", size: 6 }]
          }
        ]
      }
    ]
  },
  {
    label: "Acuerdos privados",
    path: "acuerdos-privados",
    to: "acuerdos",
    size: 3,
    api: "/api/acuerdos",
    columns: [{ id: "nombre", label: "Acuerdo" }, { id: "estado", label: "Estado" }]
  },
  {
    label: "Listado de páginas maliciosas",
    path: "listado-de-paginas-maliciosas",
    to: "paginas-maliciosas",
    size: 3,
    api: "/api/paginas-maliciosas",
    columns: [{ id: "dominio", label: "Dominio", minWidth: 320 }, { id: "categoria", label: "Categoría" }]
  },
  {
    label: "Otros reportes",
    path: "otros-reportes",
    to: "otros",
    size: 3,
    active: true,
    api: "/api/otros",
    columns: [{ id: "titulo", label: "Título" }, { id: "descripcion", label: "Descripción" }]
  }
];

const BASE = "/reportes";
function normalizeTo(to) {
  return to?.startsWith("/") ? `${BASE}${to}` : `${BASE}/${to}`;
}
function stripBase(pathname) {
  return pathname.startsWith(`${BASE}/`) ? pathname.slice(BASE.length + 1) : "";
}
function findPath(nodes, predicate, trail = []) {
  for (const n of nodes) {
    const nextTrail = [...trail, n];
    if (predicate(n)) return nextTrail;
    if (n.children) {
      const res = findPath(n.children, predicate, nextTrail);
      if (res) return res;
    }
  }
  return null;
}
const LEAVES = (() => {
  const acc = [];
  (function walk(nodes) {
    nodes.forEach((n) => {
      if (n.children?.length) walk(n.children);
      else if (n.to) acc.push(n);
    });
  })(BUTTONS);
  return acc;
})();
function findLeafByPathname(pathname) {
  const relative = stripBase(pathname);
  return LEAVES.find((l) => l.to === relative);
}

function NodeSubMenu({ node, onNavigate }) {
  const hasChildren = !!(node.children && node.children.length);
  if (!hasChildren) {
    return <RMenuItem onClick={() => node.to && onNavigate(normalizeTo(node.to))}>{node.label}</RMenuItem>;
  }
  return (
    <RSubMenu
      label={node.label}
      direction="right"
      align="start"
      offsetX={0}
      offsetY={0}
      transition
      submenuOpenDelay={110}
      submenuCloseDelay={220}
      portal={false}
      viewScroll="auto"
      menuClassName="sagec-menu sagec-submenu"
    >
      {node.children.map((child) => (
        <NodeSubMenu key={child.path} node={child} onNavigate={onNavigate} />
      ))}
    </RSubMenu>
  );
}

function HoverMenuButton({ node }) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentRel = stripBase(location.pathname);
  const hasChildren = !!(node.children && node.children.length);
  const anyChildSelected = hasChildren && node.children.some((c) => (c.to ? currentRel.startsWith(c.to) : false));
  const [isOpen, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const anchorRef = useRef(null);
  const closeTimer = useRef(null);
  const ACTIVE_BG = "#003B8D";
  const ACTIVE_BORDER = "#003B8D";
  const ACTIVE_COLOR = "#FFFFFF";
  const DEFAULT_BG = "#FFFFFF";
  const DEFAULT_BORDER = "#003B8D";
  const DEFAULT_COLOR = "#003B8D";
  const DEFAULT_FS = "0.8rem";
  const openMenu = () => {
    clearTimeout(closeTimer.current);
    setOpen(true);
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpen(false), 160);
  };
  if (!hasChildren) {
    const isActive = hover || (node.to && currentRel.startsWith(node.to));
    return (
      <span onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} style={{ display: "block", width: "100%" }}>
        <PageButtonWhite
          width="100%"
          fs={DEFAULT_FS}
          onClick={() => node.to && navigate(normalizeTo(node.to))}
          bgColor={isActive ? ACTIVE_BG : DEFAULT_BG}
          border={isActive ? ACTIVE_BORDER : DEFAULT_BORDER}
          color={isActive ? ACTIVE_COLOR : DEFAULT_COLOR}
        >
          {node.label}
        </PageButtonWhite>
      </span>
    );
  }
  const isActive = isOpen || anyChildSelected;
  return (
    <>
      <style>{MENU_CSS}</style>
      <span ref={anchorRef} onMouseEnter={openMenu} onMouseLeave={scheduleClose} style={{ display: "block", width: "100%" }}>
        <PageButtonWhite
          width="100%"
          fs={DEFAULT_FS}
          bgColor={isActive ? ACTIVE_BG : DEFAULT_BG}
          border={isActive ? ACTIVE_BORDER : DEFAULT_BORDER}
          color={isActive ? ACTIVE_COLOR : DEFAULT_COLOR}
        >
          {node.label}
        </PageButtonWhite>
      </span>
      <RControlledMenu
        state={isOpen ? "open" : "closed"}
        anchorRef={anchorRef}
        onClose={() => setOpen(false)}
        direction="bottom"
        align="start"
        offsetX={0}
        offsetY={6}
        transition
        portal={false}
        viewScroll="auto"
        onMouseEnter={() => clearTimeout(closeTimer.current)}
        onMouseLeave={scheduleClose}
        menuClassName="sagec-menu"
      >
        {node.children.map((child) => (
          <NodeSubMenu key={child.path} node={child} onNavigate={(to) => navigate(to)} />
        ))}
      </RControlledMenu>
    </>
  );
}

function RouteDrivenSubView() {
  const location = useLocation();
  const navigate = useNavigate();
  const leaf = findLeafByPathname(location.pathname);

  useEffect(() => {
    const rel = stripBase(location.pathname);
    if (rel && !leaf) navigate("/404", { replace: true });
  }, [location.pathname, leaf, navigate]);

  if (leaf && leaf.to === "supervision/monitoreo") {
    return <OPReport />;
  }

  const trail = leaf ? findPath(BUTTONS, (n) => n === leaf) || [] : [];
  const breadcrumbText = ["Reportes", ...trail.map((n) => n.label)].join(" / ");

  if (!leaf) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography sx={{ color: "text.secondary", textAlign: "center", py: 6 }}>
          Selecciona una opción del menú para ver el detalle.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <GenericTextTable
        breadcrumb={breadcrumbText}
        title={(leaf.label || "").toUpperCase()}
        columns={leaf.columns || []}
        api={leaf.api}
        filtersConfig={leaf.filters || []}
        selectable={true}
      />
    </Box>
  );
}

export default function ReportesPrincipal() {
  const { includeRol: _includeRol } = useContext(GeneralContext);
  const items = BUTTONS;
  return (
    <PageBody>
      <Stack spacing={2} sx={{ pb: 2 }}>
        <Box>
          <Grid container spacing={1.5}>
            {items.map((item) => (
              <Grid key={item.path} size={item.size ?? 12} xs={item.xs} sm={item.sm} md={item.md} lg={item.lg} xl={item.xl}>
                <HoverMenuButton node={item} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
      <RouteDrivenSubView />
    </PageBody>
  );
}
